var addHardware = (function () {
  const init = function () {
    $("#add-hardware-button").on("click", function () {
      const viewModel = {
        Version: $("#Version").val(),
        Description: $("#Description").val(),
      };

      $.ajax({
        url: "/Hardwares/Add",
        method: "POST",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(viewModel),
      }).done(function (data) {
        if (data.success) {
          $.notificationSuccess(data.header, data.message);
          setTimeout(function () {
            document.location = "/Hardwares/Index";
          }, reloadDelay);
        } else {
          $.notificationAlert(data.header, data.message);
        }
      });
    });
  };

  return {
    init: init,
  };
})();
